// Shared by the Events header stats and the Data tab so both count the same way.

// Statuses that mean an event was approved (whatever happened after).
export const APPROVED_STATUSES = [
  'approved',
  'event ended',
  'event ending',
  'in progress',
  'donation requested',
  'donation approved',
  'reimbursement submitted',
  'reimbursement requested',
  'reimbursement approved',
];

// Excluded from stats cards only (still shown in grids)
export const EVENT_IDS_EXCLUDED_FROM_STATS = [ 13884, 13885 ];

// Donation rules, as printed on the check letters (charity-checks-api checkLetters/dtg.js)
export const DONATION_PER_DRIVE = 30;
export const MAX_DRIVES_PER_EVENT = 200;
export const MAX_DONATION_PER_EVENT = DONATION_PER_DRIVE * MAX_DRIVES_PER_EVENT; // 6000
